export default "__VITE_ASSET__BTEMmyTg__"